<div class="flex_col" style="width: 100%; height: 100%">
  <div style="overflow-y: auto; flex: 1">
    <div id="nodes_container">
      @for (node of nodes; track node) {
        <div class="node">
          <div class="node_icon_container" [ngClass]="node.status">
            <fa-icon class="icon" [icon]="icons[node.icon]"></fa-icon>
            @if (node.index >= 0) {
              <div style="position: absolute; font-size: 10px; bottom: 0; font-weight: bold; right: 6px">
                {{ node.index + 1 }}
              </div>
            }
          </div>
          <div class="node_info" [style.z-index]="expandedNode == node ? '10' : '5'">
            <div class="node_info_connection"></div>
            <mat-expansion-panel
              style="flex: 1"
              [style.pointer-events]="node.icon === 'absence' ? 'none' : 'auto'"
              [hideToggle]="node.icon === 'absence'"
              [expanded]="expandedNode == node"
              (opened)="expandedNode = node"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  @if (node.link) {
                    <a [href]="node.link" target="_blank" (click)="$event.stopPropagation()">{{ node.header }}</a>
                  }
                  @if (!node.link) {
                    {{ node.header }}
                  }
                </mat-panel-title>
                <mat-panel-description>
                  @if (node.icon !== "absence") {
                    <div style="text-align: center; width: 100%">
                      @if (node.day_start_time >= 0) {
                        <i
                          >{{ dayMinutesToTimeString(node.day_start_time) }} -
                          {{
                            dayMinutesToTimeString(node.day_start_time + (node.duration || node.estimated_duration))
                          }}Uhr</i
                        >
                      }
                    </div>
                  }
                </mat-panel-description>
              </mat-expansion-panel-header>
              @if (node.icon === "driving") {
                <div style="font-size: 0.85rem">
                  <b style="margin-right: 2px">
                    @if (node.status === "done") {
                      <u> {{ Math.round(node.duration) }}min </u>
                    }
                  </b>
                  ({{ Math.round(node.estimated_duration) }}min EST)
                </div>
              }
              @if (node.icon === "working") {
                <div class="flex_col">
                  <div class="flex_row">
                    <i>Dauer: {{ dayMinutesToTimeString(node.duration, true) }}h</i>
                  </div>
                  <div>
                    {{ node.main_description }}
                  </div>
                </div>
              }
            </mat-expansion-panel>
          </div>
        </div>
        @if (nodes.indexOf(node) != nodes.length - 1) {
          <div class="node_connection"></div>
        }
      }
    </div>
  </div>
  <div style="width: 100%; border-top: 1px solid lightgray; padding-top: 4px" class="flex_row">
    @for (icon of ["driving", "working"]; track icon) {
      <div class="flex_row" style="margin: auto">
        <fa-icon style="margin-right: 4px" [icon]="icons[icon]"></fa-icon>
        {{ dayMinutesToTimeString(durationSums[icon], true) }}h
      </div>
    }
    <div style="margin: auto">Gesamt: {{ dayMinutesToTimeString(durationSums.total, true) }}h</div>
  </div>
</div>
